import { QC_TASK_TABS } from '../constants/qcTaskDomainConstants';

/**
 * Maps UI tab → `req_status` query param expected by workflow / batch / assignment APIs.
 *
 * @param {string} tab - One of `QC_TASK_TABS` values.
 * @returns {'OPEN' | 'IN-PROGRESS' | 'SUBMITTED'}
 */
export function reqStatusFromTab(tab) {
  if (tab === QC_TASK_TABS.SAVE_FOR_LATER) return 'IN-PROGRESS';
  if (tab === QC_TASK_TABS.SUBMITTED) return 'SUBMITTED';
  return 'OPEN';
}
